import { Card } from 'react-bootstrap';
import Icon from './Icon';
import styled from 'styled-components';
import { COLORS } from '../styles/colors';
import { slugify } from '../utils/slugUtils';
import ExternalLink from './ExternalLink';

interface IProps {
  project: Partial<Project>;
}

const ProjectCard = ({ project }: IProps) => {
  // Generate slug from project name
  const projectSlug = project.name ? slugify(project.name) : '';
  const internalHref = `/${projectSlug}`;

  const isInternal = (project.display_type ?? 'Full') === "Full";
  const href = isInternal ? internalHref : (project.website || internalHref);

  return (
    <Card style={{ marginBottom: 0 }}>
      <Card.Body
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <H6 style={{ textAlign: 'end' }}>
            {project.type}
          </H6>
          <ExternalLink href={href}>
            <Card.Title
              style={{
                fontSize: '1.6rem',
                fontWeight: 400,
                color: COLORS.Primary,
              }}
            >
              {project.name}
            </Card.Title>
          </ExternalLink>
          <Card.Text style={{ fontSize: '1.25rem' }}>
            {project.sub_name}
          </Card.Text>

          {project.country_of_origin && (
            <H6
              className="title-category"
              style={{
                marginTop: '0.5rem',
              }}
            >
              ORIGIN:{' '}
              <span style={{ color: COLORS.GrayDark }}>
                {project.country_of_origin}
              </span>
            </H6>
          )}
        </div>

        <ExternalLink href={href}>
          <Card.Link
            as="span"
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <span>Read more</span>
            <Icon icon="chevronRight" />
          </Card.Link>
        </ExternalLink>
      </Card.Body>
    </Card>
  );
};

export default ProjectCard;

export const ProjectCardSkeleton = () => {
  return (
    <Card style={{ marginBottom: 0 }}>
      <Card.Body
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: '0.3rem',
        }}
      >
        <Card.Link className="placeholder col-6" />
        <div className="title-category placeholder col-7" />
        <div className="title-category placeholder col-6" />
        <p className="placeholder col-12" />
        <p className="placeholder col-7" />
        <Card.Link className="placeholder col-6" />
      </Card.Body>
    </Card>
  );
};

const H6 = styled.h6`
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: bold;
`;
